import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarCheck, faCalendarDay, faCalendarDays, faCheckToSlot, faFilter, faRotateLeft } from "@fortawesome/free-solid-svg-icons";

//STYLES
import { Avancado } from "./styles";

//COMPONENTS
import Input from "../../../../../../Components/CustomUi/input";
import Footer from "../../../../../../Components/Footer";
import ButtonCustom from "../../../../../../Components/ButtonCustom";
import DatePickerCustom from "../../../../../../Components/CustomUi/datePicker";
import { Inline } from "../../../../../../Components/CustomUi/inline";
import { SelectMulti } from "../../../../../../Components/CustomUi/SelectMulti";
import { dummy_operacoes } from "../cadastro/components/planejada/meta/dummy";
import DateRangePickerCustom from "../../../../../../Components/CustomUi/dateRangePicker";

//PROPS
interface Props {
    filtrar_titulo: string;
    setFiltrar_titulo: React.Dispatch<React.SetStateAction<string>>;
    filtrar_tipos_operacao: any[];
    setFiltrar_tipos_operacao: React.Dispatch<React.SetStateAction<any[]>>;
    filtrar_intervalo_inicial: any;
    setFiltrar_intervalo_inicial: React.Dispatch<React.SetStateAction<any>>;
    filtrar_intervalo_final: any;
    setFiltrar_intervalo_final: React.Dispatch<React.SetStateAction<any>>;
    onClose: Function;
}

export const FiltroAvancado: React.FC<Props> = ({ filtrar_titulo, setFiltrar_titulo, onClose, filtrar_tipos_operacao, 
    setFiltrar_tipos_operacao, filtrar_intervalo_inicial, setFiltrar_intervalo_inicial, filtrar_intervalo_final, setFiltrar_intervalo_final
 }) => {

    //STATES
    const [tipos_de_operacao, setTipos_de_operacao] = useState([]);
    const [open_tipos_de_operacao, setOpen_tipos_de_operacao] = useState<boolean>(false);
    const [data_inicial, setData_inicial] = useState<any>('');
    const [data_final, setData_final] = useState<any>('');
    const [range_datas, setRange_datas] = useState<any[]>([]);
    const [titulo_atividade, setTitulo_atividade] = useState<string>('');
    const [fake_loading, setFake_loading] = useState<boolean>(false);

    useEffect(() => {
        if (data_inicial) {
            if (!data_final || dayjs(data_final) < dayjs(data_inicial)) {
                setData_final(data_inicial);
            }
        }
    }, [data_inicial]);

    useEffect(() => {
        let valor_titulo_atividade = filtrar_titulo ? filtrar_titulo : '';
        let valor_tipos_de_operacao = filtrar_tipos_operacao ? filtrar_tipos_operacao : [];
        let valor_data_inicial = filtrar_intervalo_inicial ? filtrar_intervalo_inicial : '';
        let valor_data_final = filtrar_intervalo_final ? filtrar_intervalo_final : '';

        setTitulo_atividade(valor_titulo_atividade);
        setTipos_de_operacao(valor_tipos_de_operacao);
        setData_inicial(valor_data_inicial);
        setData_final(valor_data_final);

    }, []);
    
    function aplicarFiltro() {
        setFake_loading(true);
        let valor_titulo_atividade = titulo_atividade ? titulo_atividade : '';
        let valor_tipos_de_operacao = tipos_de_operacao ? tipos_de_operacao : [];
        let valor_data_inicial = range_datas?.length > 0 ? range_datas?.[0] : '';
        let valor_data_final = range_datas?.length > 0 ? range_datas?.[1] : '';

        setTimeout(() => {
            setFiltrar_titulo(valor_titulo_atividade);
            setFiltrar_tipos_operacao(valor_tipos_de_operacao);
            setFiltrar_intervalo_inicial(valor_data_inicial);
            setFiltrar_intervalo_final(valor_data_final);
        }, 300);

        setTimeout(() => {
            onClose()
        }, 500);
    };

    function resetarCampos() {
        setTitulo_atividade('');
        setTipos_de_operacao([]);
        setData_inicial('');
        setData_final('');
    }

    return (
        <Avancado>

            <Input 
                label="Título da atividade"
                placeholder="Título da atividade"
                value={titulo_atividade}
                onChange={setTitulo_atividade}
                opcional
            />

            <SelectMulti
                label={`Tipos de operação`}
                placeholder="Selecione as finalidades da operação"
                descricaoItem="nome"
                idItem="cod"
                items={dummy_operacoes ?? []}
                selecteds={tipos_de_operacao}
                onChange={setTipos_de_operacao}
                open={open_tipos_de_operacao}
                trigger={setOpen_tipos_de_operacao}
                icon={faCheckToSlot}
                opcional
            />

            <DateRangePickerCustom 
                label="Intervalo de datas"
                value={range_datas}
                onChange={setRange_datas}
                icon={faCalendarDays}
                width={250}
                opcional
            />

            <Footer>
                <ButtonCustom 
                    onClick={()=>{aplicarFiltro()}}
                    icon={<FontAwesomeIcon icon={faFilter} />}
                    loading={fake_loading}
                >
                    Aplicar
                </ButtonCustom>
                <ButtonCustom 
                    onClick={()=>{resetarCampos()}}
                    icon={<FontAwesomeIcon icon={faRotateLeft} />}
                    loading={fake_loading}
                    type={"secondary"}
                    danger
                >
                    Resetar
                </ButtonCustom>
            </Footer>
        </Avancado>
    )
}